import { render, staticRenderFns } from "./ClientAddressesModal.vue?vue&type=template&id=4bd934e3&"
import script from "./ClientAddressesModal.vue?vue&type=script&lang=js&"
export * from "./ClientAddressesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports